import React from "react";

interface Campaign {
  id: number;
  name: string;
  type: string;
  setting: string;
  description?: string;
  world?: string;
  isPublic: boolean;
  maxPlayers?: number;
  users: {
    id: number;
    username: string;
    name: string;
    email: string;
  }[];
}

interface CampaignOverviewProps {
  campaign: Campaign;
}

const CampaignOverview: React.FC<CampaignOverviewProps> = ({ campaign }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="space-y-4">
        <h2 className="text-sm font-semibold text-amber-400 tracking-wide uppercase mb-4">
          Campaign Information
        </h2>
        <div>
          <p className="text-zinc-300">
            <strong className="text-amber-400">Type:</strong> {campaign.type}
          </p>
        </div>
        <div>
          <p className="text-zinc-300">
            <strong className="text-amber-400">Setting:</strong> {campaign.setting}
          </p>
        </div>
        {campaign.world && (
          <div>
            <p className="text-zinc-300">
              <strong className="text-amber-400">World:</strong> {campaign.world}
            </p>
          </div>
        )}
        <div>
          <p className="text-zinc-300">
            <strong className="text-amber-400">Visibility:</strong>
            <span
              className={`ml-2 px-2 py-0.5 text-xs ${
                campaign.isPublic
                  ? "bg-emerald-900/30 text-emerald-300 border border-emerald-800"
                  : "bg-zinc-800 text-zinc-400 border border-zinc-700"
              }`}
            >
              {campaign.isPublic ? "Public" : "Private"}
            </span>
          </p>
        </div>
        {campaign.maxPlayers && (
          <div>
            <p className="text-zinc-300">
              <strong className="text-amber-400">Max Players:</strong> {campaign.maxPlayers}
            </p>
          </div>
        )}
        <div>
          <p className="text-zinc-300">
            <strong className="text-amber-400">Current Players:</strong>{" "}
            {campaign.users?.length || 0}
          </p>
        </div>
      </div>

      {campaign.description && (
        <div className="space-y-4">
          <h2 className="text-sm font-semibold text-amber-400 tracking-wide uppercase mb-4">
            Description
          </h2>
          <div className="bg-zinc-800 p-4 border border-zinc-700">
            <p className="text-zinc-300 leading-relaxed">{campaign.description}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default CampaignOverview;
